import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=53fb6f89&scoped=true"
import script from "./pageFooter.vue?vue&type=script&lang=js"
export * from "./pageFooter.vue?vue&type=script&lang=js"
import style0 from "./pageFooter.vue?vue&type=style&index=0&id=53fb6f89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fb6f89",
  null
  
)

export default component.exports